import React from "react";
import { product } from "../../data/product";
type CtaButtonProps = {
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  href?: string;
};
export function CtaButton({
  children,
  icon,
  className = "",
  href = product.checkoutUrl
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex min-h-[56px] w-full items-center justify-center gap-2 rounded-full bg-wine px-6 py-4 text-center text-[15px] font-semibold leading-snug text-white shadow-[0_12px_24px_-12px_rgba(86,18,54,0.7)] transition-[background-color,transform] duration-150 ease-out hover:bg-wine-hover active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wine focus-visible:ring-offset-2 focus-visible:ring-offset-cream sm:w-auto sm:px-10 sm:text-base ${className}`} data-id="element-174" data-mp="20u285romqmbl">
      {icon}
      <span data-id="element-175" data-mp="1371zxponyklb">{children}</span>
    </a>;
}